import React from "react";

const ComplianceSummaryBar = ({ totalPercentage, isValid }) => {
  const percentage = Number(totalPercentage) || 0;
  const isExact = percentage === 100;
  const isOver = percentage > 100;

  return (
    <div className="flex items-center gap-4 flex-1 min-w-0">
      <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
          <svg
            className="w-5 h-5 text-green-600"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              fillRule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clipRule="evenodd"
            />
          </svg>
      </div>
      <div>
          <p className="text-sm font-semibold text-gray-900">
            Compliance Allocation:{" "}
            <span
              className={
                isExact
                  ? "text-green-600"
                  : isOver
                  ? "text-red-600"
                  : "text-gray-900"
              }
            >
              {percentage}%
            </span>
          </p>
          <p
            className={`text-sm font-medium ${
              isExact && isValid ? "text-green-600" : "text-gray-500"
            }`}
          >
            Validation Status:{" "}
            {isExact && isValid ? "Ready to Update" : "Complete allocation to update"}
          </p>
      </div>
    </div>
  );
};

export default ComplianceSummaryBar;
